// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1jEpe","footer":"ModalError_footer__2pTFc"};